import { TeamDetails } from '../../dashboard/team-list/team-detail/[teamId]';
import type { DynamicObjectInterface /*AttachmentImageBA*/ } from '../../../sdk/type';
import { REACT_APP_COUNTRY } from '../../../envVars';
import { DashboardProps } from '../dashboardConfig';
import MyTeamMulti from './MyTeamMulti';

export interface ProgressType {
  weighingDate: Date;
  checked: boolean;
}

export const MyTeam = (props: DashboardProps) => {
  const { index, campaignData, decodedData } = props;

  const isMultiTeamView =
    REACT_APP_COUNTRY === 'MY' && campaignData[index]?.configJson?.campaignMode === 'MULTI';

  if (isMultiTeamView) {
    return <MyTeamMulti dataCampaign={campaignData[index]} decodedData={decodedData} />;
  }

  return (
    <TeamDetails
      dataCampaign={campaignData[index]}
      decodedData={decodedData}
      index={index}
      role={
        campaignData[index].enrollment.some((i: DynamicObjectInterface) => i.enrollmentType === 'COACH')
          ? 'COACH'
          : 'PARTICIPANT'
      }
      myTeamId={
        campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'PARTICIPANT')?.teamId ??
        campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'COACH')?.teamId
      }
    />
  );
};
